import { useState } from "react";

const useInput = (validator, initialValue = "") => {
  const [value, setValue] = useState(initialValue);
  const [hasFocused, setHasFocused] = useState(false);

  const isValid = validator(value);
  const hasError = !isValid && hasFocused;

  const valueChangeHandler = (event, customValue) => {
    if (customValue) {
      setValue(customValue);
    } else {
      setValue(event && event.hasOwnProperty("target") ? event.target.value : event);
    }
  };

  const inputBlurHandler = (event) => {
    setHasFocused(true);
  };

  const reset = () => {
    setValue("");
    setHasFocused(false);
  };

  return {
    value,
    isValid,
    hasError,
    valueChangeHandler,
    inputBlurHandler,
    reset,
  };
};

export default useInput;
